import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchBlogList } from "@/lib/api";
import { PageHero, Section } from "@/components/Section";
import { Wrench, ArrowUpRight } from "lucide-react";

const BlogList = () => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchBlogList({ limit: 60, q: q || undefined }).then((r) => { setItems(r.items); setTotal(r.total); setLoading(false); });
  }, [q]);

  return (
    <>
      <PageHero
        eyebrow="Workshop Journal"
        title="Hand-tools knowledge, straight from the floor"
        intro="Buying guides, manufacturing deep-dives, expo recaps and product launches — written by the team behind Jhalani Tools."
        breadcrumbs={<>Home / <span className="text-white">Blog</span></>}
      />
      <Section>
        <div className="flex justify-between items-center mb-8 flex-wrap gap-4">
          <div className="eyebrow">{total} articles</div>
          <input
            type="search"
            placeholder="Search articles..."
            defaultValue={q}
            onKeyDown={(e) => { if (e.key === "Enter") setQ(e.currentTarget.value); }}
            data-testid="blog-search"
            className="bg-white border border-[var(--jt-border)] px-3 py-2 text-sm font-mono focus:outline-none focus:border-[var(--jt-primary)] w-full sm:w-72"
          />
        </div>
        {loading ? (
          <div className="font-mono text-sm text-[var(--jt-text-muted)]">Loading articles...</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
            {items.map((b) => (
              <Link key={b.slug} to={`/blog/${b.slug}`} className="jt-card group block" data-testid={`blog-item-${b.slug}`}>
                <div className="aspect-[16/10] bg-[var(--jt-ink)] flex items-center justify-center">
                  <Wrench className="w-12 h-12 text-white/30" />
                </div>
                <div className="p-5">
                  <div className="font-mono text-[0.65rem] tracking-widest uppercase text-[var(--jt-text-muted)] mb-2">{b.date || "Journal"}</div>
                  <h3 className="font-display font-bold uppercase text-base leading-tight line-clamp-2 group-hover:text-[var(--jt-primary)]">{b.title}</h3>
                  <p className="mt-2 text-sm text-[var(--jt-text-muted)] line-clamp-3">{b.excerpt}</p>
                  <div className="mt-3 inline-flex items-center gap-1 font-mono text-xs text-[var(--jt-primary)] uppercase tracking-widest">
                    Read <ArrowUpRight className="w-3 h-3" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </Section>
    </>
  );
};

export default BlogList;
